import Vue from 'vue'
import Vuex from 'vuex'
import common from './modules/common/common'
import login from './modules/login/login'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    common,
    login
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/store.js